import React, { useState, useEffect } from 'react';
import { Modal, Radio, Select } from 'antd';
import { Button } from 'components/Button';
import moment from 'moment';
import { Api } from 'services';
import confrimationImg  from '../../../Assets/aulasMarket/confirmationImg.svg'

const FreeCourseConfirmationModal = ({ freeConfirmModal, setFreeConfirmModal, freeCourseName, handleFree, freeCourseType, courseId }) => {

    const [loader, setLoader] = useState(false)
    const [batches, setBatches] = useState([]);
    const [selectedBatchId, setSelectedBatchId] = useState(null);

    useEffect(() => {
        if (freeCourseType === 'course' && courseId) {
            Api.get(`/market/courseDetails`).params({ id: courseId, preview: false }).send((response) => {
                if (response && response.course && response.course.batches) {
                    setBatches(response.course.batches);
                    if (response.course.batches.length > 0) {
                        setSelectedBatchId(response.course.batches[0].id);
                    }
                }
            });
        }
    }, [courseId, freeCourseType]);

    const handleCancel = () => {
        console.log("376391");
        setFreeConfirmModal(false);
    };


    return (
        <div 
        onClick={(e) => {e.stopPropagation()}}
        >

            <Modal
                className="modal-round-corner"
                open={freeConfirmModal}
                footer={null}
                //centered={true}
                // width={"50%"}
                closable={false}
                bodyStyle={{ borderRadius: "10px" }}
                onCancel={() => handleCancel()}
            >
                <div style={{textAlign:"center"}}>
                    <img src={confrimationImg}/>
                </div>
                <div style={{ textAlign: "center", fontSize: "21px", color: "#191919", fontWeight: "bold", }}>Confirm</div>
                <div
                    style={{
                        marginTop: "10px",
                        textAlign: 'center'
                    }}
                >
                    Are you sure you want to enroll to
                    <span style={{
                        fontSize: "16px",
                        color: "#636363",
                        fontWeight: "bold",
                    }}>{` "${freeCourseName}"`}</span>
                    <span> {freeCourseType == 'studyMaterial' ? 'study material?' : freeCourseType == 'testSeries' ? 'test series?' : freeCourseType == 'videoResource' ? 'video course?': 'course?'}</span>

                </div>

                {freeCourseType === 'course' && batches && batches.length > 0 && (
                    <div style={{ marginTop: '20px', textAlign: 'left', padding: '0 20px', fontFamily: 'Roboto' }}>
                        <div style={{ fontSize: '13px', fontWeight: '600', color: '#191919', marginBottom: '5px' }}>
                            Select Batch <span style={{ color: 'red' }}>*</span>
                        </div>
                        <div style={{ width: '100%', border: '1px solid #d9d9d9', borderRadius: '8px', overflow: 'hidden' }}>
                            <Select
                                bordered={false}
                                placeholder="Select a batch"
                                style={{ width: '100%' }}
                                value={selectedBatchId}
                                onChange={(value) => setSelectedBatchId(value)}
                            >
                                {batches.map(batch => (
                                    <Select.Option key={batch.id} value={batch.id}>
                                        {batch.name} (Starts: {moment(batch.startDate).format("DD MMM YYYY")})
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>
                    </div>
                )}

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        marginTop: "30px",
                    }}
                >
                    <div>
                        <Button
                                onClick={(e)=>{e.stopPropagation(), handleCancel()}}
                            >
                                NO
                        </Button>
                    </div>
                    <div>
                        <Button
                            loading={loader}
                            type='primary'
                            disabled={freeCourseType === 'course' && batches && batches.length > 0 && !selectedBatchId}
                            onClick={(e) => {e.stopPropagation(), handleFree(selectedBatchId),setLoader(true) }}

                        >
                            YES
                        </Button>
                    </div>
                </div>
            </Modal>

        </div>
    );
};
export default FreeCourseConfirmationModal;